import { RootState } from '@/redux/store';
import { LoadingStatuses } from '@/constants/constants';

export const selectProcessingTasksIsLoading = (state: RootState) => {
  return state.dataTable?.processingTasks?.status === LoadingStatuses.pending;
};
